import { frontendURL } from '../../../../helper/URLHelper';
import SettingsShellWrapper from '../SettingsShellWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/billing'),
      // No installationTypes gate: billing is not cloud-only. Self-hosted
      // installs get the region-driven manual lane and credit meters, while
      // the Stripe-specific cards inside Index.vue stay behind isOnChatwootCloud.
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsShellWrapper,
      children: [
        {
          path: '',
          name: 'billing_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
